import React from 'react';
import PropTypes from 'prop-types';
import { get, intersection, isEmpty } from 'lodash';
import Form from 'kepler/lib/components/Form';
import Select from 'kepler/lib/components/Select';
import { MARKETPLACES, MISC } from '../lib/constants';
import getContent from '../lib/dictionaryFetcher';
import { checkForEmptyCategory } from '../lib/helpers';

class CategoriesDropdown extends React.Component {
  state = {
    fixDropdown: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    // call this function when mounted once because in some cases
    // window.scrollY can have a initial non-zero value and may exceed 125
    // so we need to fix dropdown in such case
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  render() {
    const {
      activeKey,
      categories,
      changeTab,
      featured,
      experimentation,
      tools
    } = this.props;

    let categoryOptions = [];
    categories.forEach((category, index) => {
      let categoryName = get(category, 'name', ''),
        title = getContent('merchanthub', `categories.${categoryName}`, ''),
        newLabel = getContent('merchanthub', 'categories.label.new', ''),
        items = get(category, 'items', []),
        newCategories = [MISC.SELLING, MISC.SHOPPING_CARTS],
        isNewCategories = newCategories.includes(categoryName),
        hasMarketplaces =
          !isEmpty(featured) || intersection(items, MARKETPLACES).length > 0,
        isEmptyCategory =
          checkForEmptyCategory(category, tools) &&
          (!isNewCategories || !hasMarketplaces),
        isNotInDiscoverExperience =
          categoryName === MISC.DISCOVER &&
          !get(experimentation, MISC.DISCOVER, false),
        isNotInMarketplacesExperience =
          categoryName === MISC.SHOPPING_CARTS &&
          !get(experimentation, MISC.MARKETPLACES, false);

      if (
        isEmptyCategory ||
        isNotInDiscoverExperience ||
        isNotInMarketplacesExperience
      ) {
        return;
      } else if (isNewCategories && hasMarketplaces && newLabel.length) {
        title = (
          <div>
            {title}
            <span
              className={`myapps-tab-new ${
                activeKey === String(index) ? 'tab-new-white' : ''
              }`}
            >
              {newLabel}
            </span>
          </div>
        );
      }

      categoryOptions.push({ label: title, value: String(index) });
    });

    return (
      <div
        id="categoryDropdown"
        style={
          this.state.fixDropdown ? { position: 'fixed', top: '61px' } : null
        }
      >
        <Form>
          <Select
            size="lg"
            value={activeKey}
            options={categoryOptions}
            onChange={changeTab}
          />
        </Form>
      </div>
    );
  }

  /**
   * This function checks if window scrollY is above a certain point
   * and update dropdown css
   * The idea is to allow banner to be scrolled away but fix dropdown top
   * at a certain point.
   */
  handleScroll() {
    this.setState({ fixDropdown: get(window, 'scrollY', 0) > 95 });
  }
}

CategoriesDropdown.propTypes = {
  categories: PropTypes.array,
  activeKey: PropTypes.string,
  changeTab: PropTypes.func,
  locale: PropTypes.string,
  featured: PropTypes.object,
  experimentation: PropTypes.object,
  tools: PropTypes.object
};

export default CategoriesDropdown;
